import { useHistory } from "react-router-dom";
import { isNil } from "lodash";

const updateParam = (name, value, params) => {
  if (isNil(value)) {
    params.delete(name);
  } else {
    params.set(name, value);
  }
};

export const useQueryParams = () => {
  const history = useHistory();

  const getParam = (name) => {
    const params = new URLSearchParams(history.location.search);
    return params.get(name);
  };

  const setParam = (name, value) => {
    const params = new URLSearchParams(history.location.search);
    updateParam(name, value, params);

    history.replace({
      pathname: history.location.pathname,
      search: params.toString(),
    });
  };

  const setParams = (newParams) => {
    const params = new URLSearchParams(history.location.search);

    Object.entries(newParams).forEach(([name, value]) => {
      updateParam(name, value, params);
    });

    history.replace({
      pathname: history.location.pathname,
      search: params.toString(),
    });
  };

  return { getParam, setParam, setParams };
};
